import { createContext, useState, useEffect } from "react";
import { getFullCatalog, getClubProducts } from "../common/products";
import { Cart } from "@cocunat/cocunat-core-js";
import { backendCheckCart } from "../common/cart";
import { userLoggedIn } from "../common/users";
import { addToCart as analyticsAddToCart } from "../common/analytics";

const MainContext = createContext<any>(null);

const MainContextProvider: React.FC = ({ children }: any) => {
  const [products, setProducts] = useState<any>({});
  const [productsClub, setProductsClub] = useState<any>([]);
  const [cart, setCart] = useState<any>();
  const [region, setRegion] = useState<any>(null);
  const [isGourmet, setIsGourmet] = useState<boolean>(false);
  const [responses, setResponses] = useState<any>({
    1: null,
    2: null,
    3: null,
    4: null,
    5: null,
  });

  const fetchCatalog = async () => {
    const response = await getFullCatalog("es", "ES");
    setProducts(response);
  };

  const fetchClubProducts = async () => {
    const response = await getClubProducts("es", "ES");
    setProductsClub(response.data);
  };

  useEffect(() => {
    fetchClubProducts();
    //fetchCatalog();
  }, []);

  async function _backendCheckCart(_cart: Object) {
    try {
      let result = await backendCheckCart(_cart);
      if (result.status === 200) {
        let cartObject = new Cart({ ...result.data }).getUpdated();
        setCart(cartObject);
      }
    } catch (err: any) {
      if (err.response && err.response.status === 409) {
        setTimeout(function () {
          window.localStorage.removeItem("cart");
        }, 1500);
      } else {
        console.log("TODO: Log this");
      }
    }
  }

  function updateCartAttributes(attributes: any, callback = () => {}) {
    let cartCopy = { ...cart };
    for (let attributeKey in attributes) {
      cartCopy[attributeKey] = attributes[attributeKey];
      if (attributeKey === "country") {
        cartCopy.address["country"] = attributes[attributeKey];
      }
    }
    cartCopy.updated = true;
    cartCopy.modified_date = new Date().toISOString();

    let user: any = userLoggedIn();
    let userData = { ...(cartCopy.userData || {}) };
    if (!attributes.hasOwnProperty("userData")) {
      userData.email = cartCopy.address.email;
      userData.first_name = cartCopy.address.first_name;
      userData.last_name = cartCopy.address.last_name;
    }
    userData.user_id = null;
    if (user) {
      userData.user_id = user.id;
    } else {
      userData.user_id = null;
      cartCopy.user_id = null;
    }
    cartCopy.userData = userData;
    setCart(cartCopy);
    callback();
  }

  function plusOneProduct(
    productId,
    subscriptionType = false,
    isPreCheckout = false
  ) {
    let cartObject = new Cart({ ...cart }).plusOne(
      productId,
      subscriptionType,
      isPreCheckout
    );
    setCart(cartObject);
    if (region) {
      let productData = null;
      for (let i = 0; i < cartObject.orderlines.length; i++) {
        if (cartObject.orderlines[i].id === productId) {
          productData = cartObject.orderlines[i];
          break;
        }
      }
      if (productData) {
        analyticsAddToCart(productData, cart, cart.orderlines, region);
      }
    }
  }

  function minusOneProduct(
    productId,
    subscriptionType = false,
    isPreCheckout = false
  ) {
    let cartObject = new Cart({ ...cart }).minusOne(
      productId,
      subscriptionType,
      isPreCheckout
    );
    setIsGourmet(isGourmetInCart(cartObject));
    setCart(cartObject);
  }

  function deleteProduct(
    productId,
    subscriptionType = false,
    isPreCheckout = false
  ) {
    let cartObject = new Cart({ ...cart }).removeProduct(
      productId,
      subscriptionType,
      isPreCheckout
    );
    setIsGourmet(isGourmetInCart(cartObject));
    setCart(cartObject);
  }

  /* TODO: Mover a core-js */
  function isGourmetInCart(_cart) {
    if (_cart.cart) {
      _cart = _cart.cart;
    }
    for (let i = 0; i < _cart.orderlines.length; i++) {
      if (
        _cart.orderlines[i].subscription_type &&
        _cart.orderlines[i].subscription_type.includes("GOURMET")
      ) {
        return true;
      }
    }
    return false;
  }

  return (
    <MainContext.Provider
      value={{
        products,
        setProducts,
        responses,
        setResponses,
        region,
        setRegion,
        productsClub,
        setProductsClub,
      }}
    >
      {children}
    </MainContext.Provider>
  );
};

export { MainContextProvider, MainContext };
